import {
  getDatabaseApiName,
  getDatabaseSearch,
  normalizeDatabaseSearchSections,
} from "features/News/services/database.service";
import { getFilterDateValueKeys } from "utils/date-filter.util";
import { searchConfig } from "config";

const createDatabaseAdapter = ({ searchContext, params }) => {
  const { currentSearchTerm, currentTimeframe, startDate, endDate, currentCategory } =
    searchContext;
  const { category } = params;

  const pageSize = searchConfig.databases.count;
  const database = getDatabaseApiName(currentCategory || category);
  const enabled = Boolean(currentSearchTerm && database);
  const dependencies = [
    currentSearchTerm,
    currentTimeframe,
    startDate,
    endDate,
    currentCategory,
    category,
  ];

  const fetchPage = async (page) => {
    if (!enabled) return { items: [], nextCursor: page, hasMore: false };
    const filteredDateValue = getFilterDateValueKeys(
      currentTimeframe,
      startDate,
      endDate
    );
    const data = await getDatabaseSearch(
      currentSearchTerm,
      filteredDateValue,
      [database],
      page,
      pageSize
    );
    const section = normalizeDatabaseSearchSections(data, [database])[0];
    const items = section?.webPages?.value || [];
    const totalValue = section?.webPages?.totalEstimatedMatches;
    const total = Number.isFinite(Number(totalValue)) ? Number(totalValue) : 0;
    const hasMore = page * pageSize < total;
    return { items, nextCursor: page + 1, hasMore, total };
  };

  return {
    idKey: "url",
    initialCursor: 1,
    fetchPage,
    dependencies,
    enabled,
    isPageMode: true,
  };
};

export default createDatabaseAdapter;
